<div *ngIf="error">
  <div class="alert alert-danger alert-dismissible fade show">
    {{ this.errorMessage }}
    <button (click)="error = false" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<form [formGroup]="bwGraphsForm">
  <div class="form-group">
    <p-floatLabel>
      <input class="form-control" formControlName="originPop" id="originPop" pInputText type="text">
      <label for="originPop">Origin pop</label>
    </p-floatLabel>
  </div>
  <div>
    <p-floatLabel>
      <input class="form-control" formControlName="destinationPop" id="destinationPop" pInputText type="text">
      <label for="destinationPop">Destination pop</label>
    </p-floatLabel>
  </div>
  <div>
    <p-floatLabel>
      <input class="form-control" formControlName="vvlanId" id="vvlanId" min="0" pInputText type="number">
      <label for="vvlanId">Vvlan id</label>
    </p-floatLabel>
  </div>
  <div>
    <p-floatLabel>
      <input class="form-control" formControlName="uniqId" id="uniqId" pInputText type="text">
      <label for="uniqId">Uniq id</label>
    </p-floatLabel>
  </div>
  <div class="d-flex justify-content-end buttons-margin-left p-float-label">
    <button (click)="onSubmit()" class="btn btn-outline-primary">
      <ng-container *ngIf="!isEditAction">
        <i aria-hidden="true" class="fa fa-plus-circle pr-2"></i>
        Add
      </ng-container>
      <ng-container *ngIf="isEditAction">
        Edit
      </ng-container>
    </button>
  </div>
</form>
